__turbopack_context__.v({
  "badge": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__badge",
  "bgImage": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__bgImage",
  "bgImageWrapper": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__bgImageWrapper",
  "container": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__container",
  "containerInner": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__containerInner",
  "content": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__content",
  "cta": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__cta",
  "ctaWrapper": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__ctaWrapper",
  "heading": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__heading",
  "headingGroup": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__headingGroup",
  "subheading": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__subheading",
  "topContent": "NotSureWhichSpecializationtoChooseLp-module-scss-module__5saipa__topContent",
});
